import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import UnstakingStepThreeBg from '../../../../../../../assets/stake/unstaking-step-three-bnb-rosn.svg';
import Header from '../../../../../../../components/Stake/header';
import OmEthPolygonIcon from '../../../../../../../assets/images/tokens/om-eth.svg';
import * as omEthPolygonStakeActions from '../../../../../../../actions/om-eth-stake-actions-polygon';
import { formatToken } from '../../../../../../../helpers/token-helper';
import Details from '../../../../../../../components/Stake/frame/details';

const UnstakeDetails = () => {
  const dispatch = useDispatch();
  const { amount } = useSelector((state) => state.OMETHPOLYGONStake.stake);

  const unstakedValue = `${formatToken(amount, 10)} QUICK OM/ETH`;

  const descriptions = [
    `There is no unstaking period for QUICKSWAP OM/ETH tokens. By clicking "Unstake" you are withdrawing your QUICKSWAP OM/ETH tokens and they will be immediately available in your wallet.`,
    'Staking Rewards will stop being earned as soon as you click "Unstake" and initiate the unstaking process.',
  ];

  return (
    <>
      <Header
        icon={OmEthPolygonIcon}
        title='QUICK OM/ETH-Unstaking'
        onClickBack={() => dispatch(omEthPolygonStakeActions.unstakeSettings())}
      />
      <Details
        title='You are unstaking:'
        token={unstakedValue}
        buttonClick={() => dispatch(omEthPolygonStakeActions.unstakeSend({ amount }))}
        descriptions={descriptions}
        textButton='Unstake'
        stepBg={UnstakingStepThreeBg}
      />
    </>
  );
};

export default UnstakeDetails;
